//@ts-nocheck

import React, { useState, useEffect } from 'react'
import AssetImage from '../../SelectImage/GridView/AssetImage/AssetImage';
import Droppable from '../Dropable';
import CreateFolder from '../CreateFolder';

import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../SelectImage/GridView/Loader';
import '../index.css';
import { Asset } from 'components/AssetPicker/utils/types';
import usePermissions from '../../../hooks/usePermissions';

export function GridComponent({ assets, selectedAsset, createFolder, handleClick, handleUpload, updateSelection, editor, multiple, size, fileAccept, getFilesFromFileSystem }) {
  return assets.map((asset: Asset) => (
    asset.new ? <CreateFolder key={'create-folder'} createFolder={createFolder} editor={editor} type='grid' /> : (
      getFilesFromFileSystem ?
        <Droppable
          key={asset.uid}
          config={{
            multiple,
            onDrop: handleUpload,
            noDragEventsBubbling: true,
            noClick: true,
            ...(size?.max && { maxSize: size?.max * (1024 * 1024) }),
            ...(size?.min && { minSize: size?.min * (1024 * 1024) })
          }}
          nativeConfig={{ accept: fileAccept?.join() ?? [] }}
        >
          <AssetImage
            updateSelection={updateSelection}
            checked={selectedAsset.uid === asset.uid}
            asset={asset}
            handleClick={handleClick}
          />
        </Droppable> :
        <AssetImage
          updateSelection={updateSelection}
          checked={selectedAsset.uid === asset.uid}
          asset={asset}
          handleClick={handleClick}
        />
    )
  )
  )
}

export function ThumbnailView({ loading, assets, selectedAsset, assetsCount, createFolder, handleClick, loadMoreGrid, handleUpload, editor, multiple, size, fileTypes, getFilesFromFileSystem, permissions, folderUid }: any) {
  const { isCreateAllowed } = usePermissions(assets, folderUid, permissions);
  const updateSelection = (_currentCheckStatus: any, asset: Asset) => {
    if (asset && asset.is_dir) handleClick(asset);
  }

  return (
    <div id='scrollableDiv' style={{ height: 265, overflow: 'auto' }} data-testid='thumbnail-view'>
      <InfiniteScroll
        loader={<Loader />}
        dataLength={assets.length}
        hasMore={assets.length < assetsCount}
        next={loadMoreGrid}
        style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)' }}
        scrollableTarget='scrollableDiv'
      >
        {loading && <Loader />}
        {isCreateAllowed && <CreateFolder key={'create-folder'} createFolder={createFolder} editor={editor} type='grid' />}
        <GridComponent
          assets={assets}
          selectedAsset={selectedAsset}
          fileAccept={fileTypes}
          createFolder={createFolder}
          editor={editor}
          handleClick={handleClick}
          handleUpload={handleUpload}
          updateSelection={updateSelection}
          multiple={multiple}
          size={size}
          getFilesFromFileSystem={getFilesFromFileSystem}
        />
      </InfiniteScroll>
    </div>
  )
}